import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerUpLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowCornerUpLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M19.8107 20.3107V9.81066H5.87132L9.12132 13.0607L8.06066 14.1213L3 9.06066L8.06066 4L9.12132 5.06066L5.87132 8.31066H21.3107V20.3107H19.8107Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerUpLeft;
